import getSocialMediaServiceBaseUrlFromType from './getSocialMediaServiceBaseUrlFromType';
const getSocialMediaAccountDisplayName = (account) => {
    var _a, _b;
    if (account.type === 'google') {
        return account.username;
    }
    if (account.type === 'facebook') {
        return (_a = account.name) !== null && _a !== void 0 ? _a : account.username;
    }
    if (account.type === 'apple') {
        return (_b = account.name) !== null && _b !== void 0 ? _b : account.username;
    }
    return `${getSocialMediaServiceBaseUrlFromType(account.type)}/${account.username}`;
};
export default getSocialMediaAccountDisplayName;
